import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isArray } from 'lodash-es';
import TextEditor from './TextEditor';
import ToolBar from '../../../../../Common/Toolbar';
import { useTranslation } from "react-i18next";
import NoDataLayer from '../../../../../Common/NoDataLayer';
import moment from 'moment';
import DOMPurify from 'dompurify';
import { isNullUndefined } from '../../../../../../common/Helpers';

function INFO_COMMENT(props) {
    const { t } = useTranslation();

    const {
        inputParam_Item = null,
        inputParam_ClassName = null,
        inputParam_UseFake = false,
        inputParam_Component = null,
        inputParam_ElementId = null,
        inputParam_AuxComponentComment = null
    } = props;

    // Parámetros de componente.
    const [commentItemSelected, setCommentItemSelected] = useState(inputParam_Item);
    const [commentItem, setCommentItem] = useState(inputParam_Item);
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    const onClickComment = (comment) => {
        setCommentItemSelected(comment);
        setIsPanelOpen(true);
    };

    const setterCommentValue = (commentValue) => {
        // Hacer set del cambio de valor para el comentario en el objeto del redux.
        setCommentItemSelected(prevState => ({
            ...prevState,
            value: commentValue
        }));
    };

    const setterCommentValueList = (commentValue) => {
        // Hacer set del cambio de valor para el comentario en el objeto del redux.
        setCommentItem(commentValue);
    };

    const onAddComment = () => {
        setCommentItemSelected(null);
        setIsPanelOpen(true);
    };

    const overflowItems = [
        {
            key: 'addComment',
            text: t('data-lang-btn-add'),
            iconProps: { iconName: 'Add' },
            onClick: () => onAddComment(),
            hidden: false
        }
    ];

    const baseComments = isArray(commentItem?.comments?.value)
        ? commentItem.comments.value
        : [];

    const auxComments = isArray(inputParam_AuxComponentComment?.items)
        ? inputParam_AuxComponentComment.items
        : [];

    const allComments = [
        ...baseComments.map(item => ({ ...item })),
        ...auxComments.map(item => ({ ...item }))
    ];

    const hasComments = allComments.length > 0;

    const renderCommentItem = (comment, index, allowClick = true) => {
        const key = comment.id ?? `comment-${index}`;

        return (
            <div
                key={key}
                className={allowClick ? 'cursor-pointer border' : 'h-100'}
                onClick={allowClick ? () => onClickComment(comment) : undefined}
            >
                <div className="text-end pe-1 border-bottom">
                    {moment(comment.date).format('DD/MM/YYYY')}
                </div>

                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(comment.value, {
                            USE_PROFILES: { html: true }
                        })
                    }}
                />
            </div>
        );
    };

    const renderNoData = () => {
        return (
            <Row className='h-100'>
                <NoDataLayer
                    text={t('data-lang-lbl-nocomment')}
                    display={true}
                    className="font-weight-bold col-auto mx-auto me-auto my-auto mb-auto"
                />
            </Row>
        );
    };

    return (
        <>
            <Card
                className="p-0 m-0 h-100 w-100"
                data-container-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.containerId : ''}
                data-component-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.id : ''}
            >
                {
                    inputParam_UseFake === false &&
                    <Card.Body
                        className='p-0 m-0 text-start rounded-top'
                        style={{
                            fontSize: "13px",
                            fontWeight: "bolder",
                            backgroundColor: "#e3e6f3",
                            color: "darkblue"
                        }}
                    >
                        <Row>
                            <Col>
                                {commentItem ? commentItem.title : ""}
                            </Col>

                            <Col className='col-auto me-auto mt-1 report-command-bar'>
                                <ToolBar
                                    overflowItems={overflowItems}
                                    styles={{
                                        root: {
                                            height: "15px",
                                            backgroundColor: "transparent"
                                        }
                                    }}
                                    display={true}
                                />
                            </Col>
                        </Row>
                    </Card.Body>
                }

                <Card.Body
                    className='p-0 m-0 rounded-top kpi h-100'
                    style={{
                        height: "20px !important",
                        overflowX: "hidden",
                        overflowY: hasComments ? "scroll" : "hidden"
                    }}
                >
                    {
                        inputParam_UseFake === false &&
                        (
                            hasComments
                                ? allComments.map((comment, index) => renderCommentItem(comment, index, true))
                                : renderNoData()
                        )
                    }

                    {
                        inputParam_UseFake === true &&
                        (
                            hasComments
                                ? allComments.map((comment, index) => renderCommentItem(comment, index, false))
                                : renderNoData()
                        )
                    }
                </Card.Body>

                {
                    isPanelOpen === true &&
                    <TextEditor
                        inputParam_ComponentType={1}
                        inputParam_Component={inputParam_Component}
                        inputParam_Item={commentItemSelected}
                        inputParam_SetterControlValueList={setterCommentValueList}
                        inputParam_ControlValueList={commentItem}
                        inputParam_ClassName={inputParam_ClassName}
                        inputParam_SetterControlValue={setterCommentValue}
                        inputParam_IsModalOpen={isPanelOpen}
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_SetterIsPanelOpen={setIsPanelOpen}
                    />
                }
            </Card>
        </>
    );
}

INFO_COMMENT.propTypes = {
    inputParam_Item: PropTypes.object.isRequired,
    inputParam_UseFake: PropTypes.bool,
    inputParam_ClassName: PropTypes.string,
    inputParam_Component: PropTypes.object,
    inputParam_ElementId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    inputParam_AuxComponentComment: PropTypes.object,
};

export default INFO_COMMENT;